var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.82994 5.2897L2.58994 1.0497C2.49698 0.955976 2.38638 0.881582 2.26452 0.830813C2.14266 0.780044 2.01195 0.753906 1.87994 0.753906C1.74793 0.753906 1.61723 0.780044 1.49537 0.830813C1.37351 0.881582 1.26291 0.955976 1.16994 1.0497C0.983692 1.23707 0.87915 1.49052 0.87915 1.7547C0.87915 2.01889 0.983692 2.27234 1.16994 2.4597L4.70994 5.9997L1.16994 9.5397C0.983692 9.72707 0.87915 9.98052 0.87915 10.2447C0.87915 10.5089 0.983692 10.7623 1.16994 10.9497C1.26338 11.0424 1.3742 11.1157 1.49604 11.1655C1.61787 11.2152 1.74834 11.2405 1.87994 11.2397C2.01155 11.2405 2.14201 11.2152 2.26385 11.1655C2.38569 11.1157 2.4965 11.0424 2.58994 10.9497L6.82994 6.7097C6.92367 6.61674 6.99806 6.50614 7.04883 6.38428C7.0996 6.26242 7.12574 6.13172 7.12574 5.9997C7.12574 5.86769 7.0996 5.73699 7.04883 5.61513C6.99806 5.49327 6.92367 5.38267 6.82994 5.2897Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.25cf4d45face3b07f68aba77f378bf35.svg";
export { ForwardRef as ReactComponent };